<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'">
			<list></list>
		</div>
	</div>
</template>
<script>
	import list from "../comp/rZhuyuan_list.vue"
	export default {
		components:{list},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.yiliaoxin.rightZhuyuanParams.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	width:100%;
	height: calc(100% - 145px);margin-top:12px;
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
